import dayjs from "dayjs";
import {
  CargoListInput,
  CargoListQuery,
  useCargoListLazyQuery,
} from "../../gen/graphql/types";
import { useMemo } from "react";
import { ReportSearchCondition } from "../../components/pages/pages.module";
import { nonNullable } from "../../utils/formats";

const getCargoList = (reports?: CargoListQuery) => {
  const reportList = (reports?.cargoList?.cargoList || [])
    .filter(nonNullable)
    .map((cargo) => cargo)
    .sort((a, b) => dayjs(b.C_DateTime).diff(dayjs(a.C_DateTime)));

  return reportList;
};

export const mapCargoListInput = (
  searchCondition: ReportSearchCondition
): CargoListInput => {
  return {
    ship_id: searchCondition?.ship_id || null,
    IMO_No: searchCondition.imo_no || null,
    C_Voyage_No: searchCondition?.Voy,
    From_DateTime: searchCondition?.From_DateTime,
    To_DateTime: searchCondition?.To_DateTime,
    pagination: searchCondition.pagination,
  };
};

export const useCargo = () => {
  const [getData, { data: response, loading: isLoading }] =
    useCargoListLazyQuery();

  const data = useMemo(() => {
    const totalPageCount = response?.cargoList?.totalPageCount || 0;
    const cargoList = getCargoList(response);

    return { totalPageCount, cargoList };
  }, [response]);

  const refetch = (searchCondition: ReportSearchCondition) => {
    const inputdata = mapCargoListInput(searchCondition);
    getData({
      variables: {
        input: {
          ...inputdata,
          pagination: {
            page: inputdata.pagination?.page,
            limit: inputdata.pagination?.limit,
          },
        },
      },
    });
  };

  return {
    isLoading,
    data,
    refetch,
  };
};
